/** Autocomplete's q is a UI convention, not a column in the safe project view. */
export function projectLookupFilter(filter: Record<string, unknown> = {}) {
  const { q, ...rest } = filter;
  const search = typeof q === "string" ? q.trim() : "";
  return search
    ? { ...rest, "name@ilike": "%" + search.replace(/[\\%_]/g, "\\$&") + "%" }
    : rest;
}
